module.exports = __webpack_public_path__ + "assets/5151b8a1a60881b327fcf436d40dc6dd.gif";